import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var MarkupIcon16Solid = forwardRefAndName('MarkupIcon16Solid', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 16
    }, props), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5967 1.58579C10.2216 1.21071 9.71293 1 9.1825 1H4.5C3.11929 1 2 2.11929 2 3.5V12.5C2 13.8807 3.11929 15 4.5 15H11.5C12.8807 15 14 13.8807 14 12.5V5.8175C14 5.28707 13.7893 4.77836 13.4142 4.40329L10.5967 1.58579ZM6.60971 6.19697C6.91515 6.47676 6.93593 6.95118 6.65614 7.25661L5.51713 8.5L6.65614 9.74339C6.93593 10.0488 6.91515 10.5232 6.60971 10.803C6.30428 11.0828 5.82986 11.062 5.55007 10.7566L4.10167 9.17548C3.75151 8.79323 3.75151 8.20677 4.10167 7.82452L5.55007 6.24339C5.82986 5.93796 6.30428 5.91717 6.60971 6.19697ZM9.34649 7.25608C9.067 6.95038 9.08824 6.47598 9.39394 6.19648C9.69964 5.91698 10.174 5.93822 10.4535 6.24392L11.8993 7.82523C12.2486 8.20727 12.2486 8.79273 11.8993 9.17477L10.4535 10.7561C10.174 11.0618 9.69964 11.083 9.39394 10.8035C9.08824 10.524 9.067 10.0496 9.34649 9.74392L10.4838 8.5L9.34649 7.25608Z"
    }))
  );
});